/* eslint-disable */
export default function() {
    window.arkDontRefreshTheseAdsOnScroll = window.arkDontRefreshTheseAdsOnScroll || [];
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    window.pbjs.que.push(function() {
        window.pbjs.addAdUnits(window.dataToSend);
    });

    window.requestAds = function() {
        var timeout = 1600;

        // lets wait for googletag.. if we dont even have google (for whatever reason) we shouldnt even be doing prebid
        new Promise((resolve) => {
            if (window.googletag.apiReady) resolve();

            let waitForGoogletag = setInterval(() => {
                if (window.googletag.apiReady) {
                    clearInterval(waitForGoogletag);
                    resolve();
                }
            }, 50)
        })
        .then(() => {
            var adSlotsToRequest = [],
                adSlotIdsToRequest = [],
                pQue = [],
                allViewableAds = viewableAds(),
                now = Date.now();

            for (let i = 0; i < allViewableAds.length; i++) {
                var adSlot = allViewableAds[i];

                // filter based on last refresh (30s)
                if (!adSlot.lastRefresh || adSlot.lastRefresh + 25000 < now) {
                    var slotID = allViewableAds[i].getSlotElementId();
                    adSlot.lastRefresh = now;
                    adSlotIdsToRequest.push(slotID);
                    adSlotsToRequest.push(adSlot);
                }
            }

            // Prebid
            pQue.push(new Promise(function (resolve, reject) {
                window.pbjs.que.push(function() {
                    window.pbjs.requestBids({
                        adUnitCodes: adSlotIdsToRequest,
                        bidsBackHandler: resolve,
                        timeout: timeout
                    });
                });
                setTimeout(resolve, (timeout + 400));
            }).catch(function (err) {
                console.error(err);
                reject(err);
            }));

            // Amazon
            pQue.push(new Promise(function (resolve, reject) {

                if (window.apstag && window.apstag.init && true) {
                    window.apstag.init({
                        pubID: 3062,
                        adServer: 'googletag',
                        videoAdServer: 'DFP',
                        bidTimeout: timeout
                    });
                }
                if (window.apstag && window.apstag.fetchBids && adSlotIdsToRequest.length) {
                    window.apstag.fetchBids({
                        slots: adSlotIdsToRequest.map(function (slot) {
                            return window.a9Slots[slot];
                        }),
                        timeout: timeout
                    }, function () {
                        window.googletag.cmd.push(function () {
                            window.apstag.setDisplayBids();
                        });
                        resolve();
                    });
                } else {
                    resolve();
                }
                setTimeout(resolve, (timeout + 400));
            }).catch(function (err) {
                console.error(err);
                reject(err);
            }));

            Promise.all(pQue).then(function() {
                sendAdserverRequest(adSlotsToRequest); 
            });
        })
    };

    function sendAdserverRequest(adSlotsToRequest) {
        window.googletag.cmd.push(function() {
            window.pbjs.que.push(function() {
                window.pbjs.setTargetingForGPTAsync();
                window.googletag.pubads().refresh(adSlotsToRequest);
            });
        });
    }

    function getScrollAds() {
        if (!window.googletag.apiReady) return;
        var adSlotsToRequest = [],
            allViewableAds = viewableAds(),
            now = Date.now();

        for (var i=0; i<allViewableAds.length; i++) {
            var adSlot = allViewableAds[i];
            // filter based on last refresh (30s)
            if (!adSlot.lastRefresh || adSlot.lastRefresh + 25000 < now) {
                adSlotsToRequest.push(adSlot);
            }
        }

        return adSlotsToRequest;
    }

    window.addEventListener('scroll', _debounce(handleScrollRefresh, 100));

    function handleScrollRefresh() {
        var allScrollAdsToRefresh = getScrollAds();
        if (allScrollAdsToRefresh && allScrollAdsToRefresh.length > 0) window.requestAds();
    }

    function checkForEmail(str) {
        // We are doing a super generic check for the @ sign, just to make sure we catch everything
        return (str.match(/@/gi)) ? true : false;
    }

    function viewableAds() {
        var slots = window.googletag.pubads().getSlots();
        return slots.filter(function (slot) {
            var slotElement = document.getElementById(slot.getSlotElementId()),
                viewabilityPercent = 0.25,
                visibleVertically,
                visibleHorizontally;
            if (slotElement) {
                var bounds = slotElement.getBoundingClientRect();

                var visibleVertically = (
                    bounds.top + bounds.height * viewabilityPercent <= window.innerHeight
                    && bounds.bottom - bounds.height * viewabilityPercent >= 0
                );

                var visibleHorizontally = (
                    bounds.left + bounds.width * viewabilityPercent <= window.innerWidth
                    && bounds.right - bounds.width * viewabilityPercent >= 0
                );
            }
            return (visibleVertically && visibleHorizontally);
        })
    }

    function _debounce (n,t){var u;return function (){var e=this,i=arguments;clearTimeout(u),u=setTimeout(function (){u=null,n.apply(e,i)},t)}};

    window.requestAds();

    window.googletag.cmd.push(function() {
        var pubads = window.googletag.pubads();
        pubads.enableSingleRequest();
        pubads.setTagForChildDirectedTreatment(0);

        var targeting = {
            build: 'cobrand',
            ksg: (localStorage.getItem('kxgannett_segs') || '').split(','),
            kuid: (localStorage.getItem('kxgannett_user') || ''),
            pageType: window.utag_data && window.utag_data.contenttype,
        };

        if (/webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i.test(navigator.userAgent)) {
            targeting.navigationtype = 'nativeapp';
        }

        for (var key in targeting) {
            if (targeting.hasOwnProperty(key)) {
                var value = targeting[key];
                if (!(typeof value === 'undefined' || value === null || value === '' || (Array.isArray(value) && !value.length))) {
                    pubads.setTargeting(key, value);
                }
            }
        }

        // Check for email in the url, and disable ad calls if one is found
        if(!checkForEmail(document.location.href)) {
            window.googletag.enableServices();
        }
    });
};
